// ©2024 Austin App House. All rights reserved.
import React from 'react';

const ControlElement = ({
  hide,
  children,
}) => (
  hide
    ? <></>
    : children
);

export default ControlElement;
